// React dependencies
import React, { useState } from 'react';

// External dependencies
import PropTypes from 'prop-types';

// Internal dependenciees
import MText from '../../../../../components/Common/MText';
import Colours from '../../../../../styles/colours';
import { IsEmpty } from '../../../../../common/checks';
import PoiButton from '../PoiButton';
import PhotoInfo from './PhotoInfo';

const PhotoStage = (props) => {
  const [selectedPhotoIdx, setSelectedPhotoIdx] = useState(0);

  const hasSetAllPhotoLocation = !IsEmpty(props.photos) && props.photos.every((photo) => !IsEmpty(photo.location));

  const isNextButtonDisabled = () => {
    if (props.photos.length === 0) {
      return true;
    }

    if (selectedPhotoIdx === props.photos.length - 1) {
      return !hasSetAllPhotoLocation;
    }

    return IsEmpty(props.photos[selectedPhotoIdx].location);
  };

  const onBackClick = () => {
    props.onScrollToTop();
    if (selectedPhotoIdx > 0) {
      setSelectedPhotoIdx((prev) => prev - 1);
    } else {
      props.onBackToPreviousStage();
    }
  };

  const onNextClick = () => {
    if (selectedPhotoIdx < props.photos.length - 1) {
      setSelectedPhotoIdx((prev) => prev + 1);
      props.onScrollToTop();
    } else if (
      selectedPhotoIdx === props.photos.length - 1
    ) {
      props.onScrollToTop();
      props.onStageComplete();
    }
  };

  return (
    <div
      className="d-flex flex-column align-items-center mx-auto"
      style={{ width: '100%' }}
    >
      <MText
        style={{ fontWeight: 400, alignSelf: 'start' }}
        size={13}
        colour={Colours.Gray}
        className="mt-3"
      >
        Uploading photos to:
        {' '}
        <span className="font-weight-bold" style={{ color: Colours.Black }}>
          {props.poiName}
        </span>
      </MText>
      <div
        className="w-100 mx-auto mt-4"
        style={{ maxWidth: '95%' }}
      >
        <PhotoInfo
          onPhotosChange={props.onPhotosChange}
          onSelectedPhotoIdxChange={(idx) => setSelectedPhotoIdx(idx)}
          photos={props.photos}
          poiAddress={props.poiAddress}
          selectedPhotoIdx={selectedPhotoIdx}
        />

        <div className="d-flex justify-content-between align-items-center w-100 mt-5">
          <PoiButton
            text="Back"
            onClick={onBackClick}
          />
          <PoiButton
            text="Next"
            disabled={isNextButtonDisabled()}
            onClick={onNextClick}
          />
        </div>

      </div>
    </div>
  );
};

PhotoStage.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.shape({
    url:      PropTypes.string,
    location: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
    description: PropTypes.string,
    takenAt:     PropTypes.shape({}),
    tags:        PropTypes.arrayOf(PropTypes.string),
  })).isRequired,
  poiName:        PropTypes.string.isRequired,
  onPhotosChange: PropTypes.func.isRequired,
  poiAddress:     PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  onStageComplete:       PropTypes.func.isRequired,
  onBackToPreviousStage: PropTypes.func.isRequired,
  onScrollToTop:         PropTypes.func.isRequired,
};

export default PhotoStage;
